module.exports = __webpack_public_path__ + "img/social-grid-gv.46361ad.jpg";